"use strict";
var AjaxObservable_1 = require('./AjaxObservable');
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/observable/dom/ajax.js
// module id = ../../../../rxjs/observable/dom/ajax.js
// module chunks = 7